import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MissionStateEnum } from '../../../../../models/MissionStateEnum';
import LinkText from '../../../../Util/Buttons/LinkText/LinkText';
import LabelData from '../../../../Util/LabelData/LabelData';
import { emptyValue } from '../constants';
type Props = {
  eventData: any;
  createAccordanceReminder: any;
  isCalendarIndicator?: boolean;
};
export const MissionEventDetail = ({ eventData, createAccordanceReminder, isCalendarIndicator }: Props) => {
  const { t } = useTranslation();

  if (!eventData) {
    eventData = {
      project: { code: emptyValue, name: emptyValue },
      type: { name: emptyValue },
      state: emptyValue,
      startDate: emptyValue,
      endDate: emptyValue,
    };
  }
  const { project, type, state, startDate, endDate } = eventData;
  return (
    <>
      <LabelData label={t('code')} data={`${project.code} ${project.name}`} reverse={true} />
      <LabelData label={t('type')} data={type && type.name && type.name} reverse={true} />
      <LabelData label={t('status')} data={t(MissionStateEnum[state])} reverse={true} />

      <div style={{ display: 'flex' }}>
        <LabelData label={t('start_date')} data={moment(startDate).format('DD/MM/YYYY')} reverse={true} />
        <LinkText
          label={t('create_reminder')}
          onClick={createAccordanceReminder}
          customStyle={{ margin: '0px 0px 3px 10px' }}
        />
      </div>
      <LabelData label={t('end_date')} data={moment(endDate).format('DD/MM/YYYY')} reverse={true} />
    </>
  );
};
